import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateApplicationField, setCurrentStep, setNextStep, syncStepWithServer } from '../Slice/unifiedFormSlice';

interface ApplicationData {
  id: string;
  name_en?: string;
  name_fa?: string;
  name?: string;
  category_id?: string | null;
  description?: string | null;
  description_fa?: string | null;
  description_en?: string | null;
  publisher_id: string;
  step: number;
  next_step?: number;
  ['next-step']?: number;
}

interface UpdateApplicationDataReturn {
  updateApplicationData: (data: ApplicationData) => void;
  error: string | null;
}

export const useUpdateApplicationData = (): UpdateApplicationDataReturn => {
  const dispatch = useDispatch();
  const [error, setError] = useState<string | null>(null);

  const updateApplicationData = useCallback(
    (data: ApplicationData) => {
      try {
        console.log('Updating application data:', data);

        // Extract next step
        const serverNextStep = data.next_step ?? data['next-step'];
        console.log('Extracted next step:', serverNextStep);

        // ذخیره فیلدها در ریداکس
        dispatch(
          updateApplicationField({
            field: 'application_id',
            value: data.id,
          }),
        );
        dispatch(
          updateApplicationField({
            field: 'en_name',
            value: data.name_en || '',
          }),
        );
        dispatch(
          updateApplicationField({
            field: 'fa_name',
            value: data.name_fa || data.name || '',
          }),
        );
        dispatch(
          updateApplicationField({
            field: 'category',
            value: data.category_id || null,
          }),
        );
        dispatch(
          updateApplicationField({
            field: 'description',
            value: data.description || null,
          }),
        );
        dispatch(
          updateApplicationField({
            field: 'fa_description',
            value: data.description_fa || null,
          }),
        );
        dispatch(
          updateApplicationField({
            field: 'en_description',
            value: data.description_en || null,
          }),
        );
        dispatch(
          updateApplicationField({
            field: 'publisher_id',
            value: data.publisher_id,
          }),
        );

        // تنظیم currentStep و nextStep
        console.log('Setting currentStep to:', data.step);
        dispatch(setCurrentStep(data.step));
        if (serverNextStep !== undefined && serverNextStep !== null) {
          console.log(`Dispatching setNextStep: ${serverNextStep}`);
          dispatch(setNextStep(serverNextStep));
        } else {
          console.warn('No valid next step provided, incrementing step');
          dispatch(setNextStep(data.step + 1));
        }

        // همگام‌سازی با سرور
        dispatch(syncStepWithServer({ currentStep: data.step, nextStep: serverNextStep ?? data.step + 1 }));

        setError(null);
      } catch (err: any) {
        console.error('Error updating application data:', err);
        setError(err.message || 'خطا در به‌روزرسانی اطلاعات اپلیکیشن');
      }
    },
    [dispatch],
  );

  return { updateApplicationData, error };
};